import ConditionalLinkWrapper from '@atoms/ConditionalLinkWrapper/ConditionalLinkWrapper';
import ProfilePicture from '@atoms/ProfilePicture/ProfilePicture';
import { IImage } from '@models/IImage';
import { ISimpleLink } from '@models/ISimpleLink';
import ProfilePictureSizeEnum from '@models/enums/ProfilePictureSizeEnum';
import classNames from 'classnames';
import { PropsWithChildren } from 'react';

interface IAuthor {
  readonly name: string;
  readonly initials: string;
  readonly role?: string;
  readonly image?: IImage;
  readonly ambassador?: boolean;
  readonly link?: ISimpleLink;
}

interface Props {
  readonly authors: IAuthor[];
  readonly profilePictureSize?: ProfilePictureSizeEnum;
  readonly defaultPictureOutlineColor?: string;
  readonly pictureBackgroundColor?: string;
  readonly showProfilePhotos?: boolean;
  readonly dataTestId?: string;
}

const MultipleAuthors = ({
  authors,
  profilePictureSize = ProfilePictureSizeEnum.Size38,
  defaultPictureOutlineColor = 'border-grey-600',
  pictureBackgroundColor = 'bg-black-100',
  showProfilePhotos = true,
  dataTestId = 'Multiple-Authors',
  children,
}: PropsWithChildren<Props>) => (
  <div className="flex items-center" data-testid={dataTestId}>
    {showProfilePhotos && (
      <div className="flex">
        {authors.map(
          ({ image, name, role, initials, ambassador, link }, index) => (
            <div
              className={classNames({ '-ml-5': index > 0 })}
              key={`${name}${role ? `-${role}` : ''}`}
            >
              <ConditionalLinkWrapper link={link}>
                <ProfilePicture
                  thumbnail={image}
                  displayOutline
                  displayOutlineColor={
                    ambassador ? 'border-yellow' : defaultPictureOutlineColor
                  }
                  displayCheck={ambassador}
                  backgroundColourClassName={pictureBackgroundColor}
                  size={profilePictureSize}
                  initials={initials}
                  dataTestId={`${dataTestId}-Author-${index}-Profile-Picture`}
                />
              </ConditionalLinkWrapper>
            </div>
          )
        )}
      </div>
    )}

    {children}
  </div>
);

export default MultipleAuthors;
